export default function Gallery() {
  const images = [
    {
      src: 'https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/3deddd2c1ed525739ec262559feabec9.png',
      alt: 'Ginetta G55 Racing'
    },
    {
      src: 'https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/02b0889ab5217856e94037e7ed995d5d.png',
      alt: 'Racing Action'
    }
  ];

  const calendar = [
    { number: '01', title: 'Etapa 1 — Brands Hatch', date: '25 de fevereiro de 2026' },
    { number: '02', title: 'Etapa 2 — Oulton Park', date: '11 de março de 2026' },
    { number: '03', title: 'Etapa 3 — Donington Park', date: '25 de março de 2026' },
    { number: '04', title: 'Etapa 4 — Snetterton 300', date: '8 de abril de 2026' },
    { number: '05', title: 'Etapa 5 — Interlagos', date: '22 de abril de 2026' }
  ];

  return (
    <section id="gallery" className="py-16 sm:py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">
            Calendário Oficial — Temporada 2026
          </h2>
          <p className="text-base sm:text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed">
            O calendário da temporada 2026 contempla cinco etapas desafiadoras em autódromos icônicos, mesclando circuitos britânicos clássicos com o lendário traçado brasileiro de Interlagos. Todas as corridas oficiais acontecem nas quartas-feiras, nos horários de 20h e 21h (Horário de Brasília).
          </p>
        </div>

        {/* Calendar Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-12 sm:mb-16">
          {calendar.map((event, index) => (
            <div 
              key={index}
              className="bg-gray-800 p-6 sm:p-8 rounded-xl border-2 border-orange-500 hover:bg-gray-750 transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/20"
            >
              <div className="text-5xl sm:text-6xl font-bold text-orange-500 mb-4 opacity-50">
                {event.number}
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-2">{event.title}</h3>
              <p className="text-sm sm:text-base text-gray-400">{event.date}</p>
            </div>
          ))}
        </div>

        {/* Image Gallery */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
          {images.map((image, index) => (
            <div 
              key={index}
              className="relative overflow-hidden rounded-xl group cursor-pointer h-64 sm:h-80 lg:h-96"
            >
              <img 
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          ))}
        </div>

        {/* Important Note */}
        <div className="mt-12 sm:mt-16 bg-orange-500/10 border-l-4 border-orange-500 p-6 sm:p-8 rounded-lg">
          <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
            <strong className="text-orange-500">Importante:</strong> Os traçados específicos e todos os detalhes oficiais de cada pista serão definidos no Regulamento Oficial, disponível no grupo do campeonato. Não perca nenhuma atualização.
          </p>
        </div>
      </div>
    </section>
  );
}
